import { Link } from 'react-router-dom';
import { faCode, faComment, faDownload, faQrcode } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as HelpCard from 'components/helpcard';
import * as Styled from 'components/onboarding-checklist/onboarding-checklist-guides/styled';
import { useOnboardingTasks } from 'components/onboarding-checklist/useOnboardingTasks';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const OnboardingChecklistGuides = () => {
    const { accountId } = useCurrentAccount();
    const { tasks } = useOnboardingTasks();

    return (
        <Styled.ChecklistGuideContainer>
            {tasks?.firstCampaign?.type === 'collect' && (
                <Styled.GridArea area={'a1'}>
                    <HelpCard.Root>
                        <HelpCard.Icon>
                            <FontAwesomeIcon icon={faCode} />
                        </HelpCard.Icon>
                        <HelpCard.Title>Embed Campaign</HelpCard.Title>
                        <HelpCard.Body>Securely collect donations on your website.</HelpCard.Body>
                        <HelpCard.Footer>
                            <Link to={`/accounts/${accountId}/settings/integrations/widgets`}>
                                Add to website
                                <HelpCard.FooterIcon />
                            </Link>
                        </HelpCard.Footer>
                    </HelpCard.Root>
                </Styled.GridArea>
            )}
            <Styled.GridArea area={tasks?.firstCampaign?.type === 'collect' ? 'a2' : 'a1'}>
                <HelpCard.Root>
                    <HelpCard.Icon>
                        <FontAwesomeIcon icon={faComment} />
                    </HelpCard.Icon>
                    <HelpCard.Title>Text-to-donate</HelpCard.Title>
                    <HelpCard.Body>
                        Enable supporters to give by texting your unique keyword.
                    </HelpCard.Body>
                    <HelpCard.Footer>
                        <Link to={`/accounts/${accountId}/settings/settings/text-to-donate`}>
                            Add Keyword
                            <HelpCard.FooterIcon />
                        </Link>
                    </HelpCard.Footer>
                </HelpCard.Root>
            </Styled.GridArea>
            <Styled.GridArea area={tasks?.firstCampaign?.type === 'collect' ? 'a3' : 'a2'}>
                <HelpCard.Root>
                    <HelpCard.Icon>
                        <FontAwesomeIcon icon={faQrcode} />
                    </HelpCard.Icon>
                    <HelpCard.Title>Scan-to-donate</HelpCard.Title>
                    <HelpCard.Body>
                        Direct donors to give using your campaign's QR Code.
                    </HelpCard.Body>
                    <HelpCard.Footer>
                        <Link
                            to={`/accounts/${accountId}/campaigns/${tasks?.firstCampaign?.id}/sharing`}
                        >
                            Download QR Code
                            <HelpCard.FooterIcon>
                                <FontAwesomeIcon icon={faDownload} />
                            </HelpCard.FooterIcon>
                        </Link>
                    </HelpCard.Footer>
                </HelpCard.Root>
            </Styled.GridArea>
        </Styled.ChecklistGuideContainer>
    );
};

export { OnboardingChecklistGuides };
